import { j as a } from "../../chunks/jsx-runtime.DGlMoOmv.js";
import * as o from "react";
import { B as T } from "../../chunks/Button.Ccj-dDdM.js";
import { T as h } from "../../chunks/Text.BGhoO_e3.js";
import { c as x } from "../../chunks/index.C4-GUKyp.js";
import { D as k } from "../../chunks/DelayedUnmount.DcDPayfx.js";
import { F as B } from "../../chunks/X20.BXgaZkFp.js";
import { u as I } from "../../chunks/use-resize-observer.CEagjEFr.js";
import { c as i } from "../../chunks/index.CxSWpsOB.js";
const S = x("tw-relative tw-w-full tw-border tw-flex tw-flex-col tw-gap-4 tw-pl-16 tw-pr-12 tw-py-14 [&>svg]:tw-absolute [&>svg]:tw-left-12 [&>svg]:tw-top-12 has-[>svg]:tw-pl-40", {
  variants: {
    appearance: {
      purple: "tw-bg-purple-200 tw-border-purple-300 tw-text-purple-800 *:data-[slot=alert-description]:tw-text-purple-800/90",
      white: "tw-bg-white tw-border-gray-400 tw-text-black *:data-[slot=alert-description]:tw-text-black",
      yellow: "tw-bg-yellow-200 tw-border-yellow-900 tw-text-yellow-900 *:data-[slot=alert-description]:tw-text-yellow-900/90"
    },
    isDismissable: {
      true: "tw-pr-56"
    },
    flush: {
      true: "tw-border-0 tw-rounded-none",
      false: "tw-rounded-8"
    },
    iconPlacement: {
      top: "[&>svg]:tw-top-12",
      center: "[&>svg]:tw-top-1/2 [&>svg]:-tw-translate-y-1/2"
    }
  },
  defaultVariants: {
    flush: !1
  }
}), E = x("tw-absolute tw-right-12 tw-top-12", {
  variants: {
    appearance: {
      purple: "tw-text-purple-800 hover:tw-text-purple-800",
      white: "tw-text-black hover:tw-text-black",
      yellow: "tw-text-yellow-900 hover:tw-text-yellow-900"
    }
  }
}), u = o.forwardRef(({
  className: e,
  appearance: t = "purple",
  iconPlacement: r = "top",
  isDismissable: n = !0,
  flush: w = !1,
  onDismiss: s,
  fadeOnDismiss: g = !0,
  collapseOnDismiss: l = !0,
  isVisible: d = !0,
  children: y,
  ...v
}, b) => {
  const [c, {
    domRect: j
  }] = I(l), {
    height: p = 0
  } = j || {}, [R, f] = o.useState(void 0), A = () => {
    const m = getComputedStyle(c.current), N = parseInt(m.marginBottom?.replace("px", "") || "0"), C = parseInt(m.marginTop?.replace("px", "") || "0");
    return p + N + C;
  };
  return o.useLayoutEffect(() => {
    l && (d ? p > 0 && f(A()) : f(0));
  }, [p, l, d]), /* @__PURE__ */ a.jsx("div", { ref: b, role: "alert", "data-state": d ? "visible" : "hidden", style: {
    height: l ? `${R}px` : "auto"
  }, className: i("tw-w-full tw-fill-mode-forwards", {
    "data-[state=hidden]:tw-animate-out data-[state=hidden]:tw-fade-out-0 !tw-duration-300": g,
    "tw-transition-all tw-overflow-hidden tw-duration-300 tw-mb-0": l
  }), ...v, children: /* @__PURE__ */ a.jsxs("div", { ref: c, className: i(S({
    appearance: t,
    isDismissable: n,
    iconPlacement: r,
    flush: w
  }), e), children: [
    y,
    n && /* @__PURE__ */ a.jsx(T, { variant: "text-only", className: i(E({
      appearance: t
    })), onClick: s, children: /* @__PURE__ */ a.jsx(B, {}) })
  ] }) });
});
u.displayName = "AlertContent";
const F = o.forwardRef(({
  isVisible: e = !0,
  fadeOnDismiss: t = !0,
  collapseOnDismiss: r = !0,
  onUnmount: n,
  ...w
}, s) => t || r ? (
  // Delay unmount for exit animations
  /* @__PURE__ */ a.jsx(k, { isMounted: e, onUnmountChildren: n, children: /* @__PURE__ */ a.jsx(u, { ref: s, isVisible: e, fadeOnDismiss: t, collapseOnDismiss: r, ...w }) })
) : e && /* @__PURE__ */ a.jsx(u, { ref: s, fadeOnDismiss: t, collapseOnDismiss: r, ...w }));
F.displayName = "Alert";
const H = o.forwardRef(({
  className: e,
  ...t
}, r) => /* @__PURE__ */ a.jsx(h, { element: "h5", typeface: "body-1-m", testId: "alert-title", "data-slot": "alert-title", ref: r, className: e, ...t }));
H.displayName = "AlertTitle";
const M = o.forwardRef(({
  className: e,
  ...t
}, r) => /* @__PURE__ */ a.jsx(h, { element: "p", typeface: "body-1", testId: "alert-description", "data-slot": "alert-description", ref: r, className: e, ...t }));
M.displayName = "AlertDescription";
export {
  F as Alert,
  M as AlertDescription,
  H as AlertTitle
};
//# sourceMappingURL=index.js.map
